import {
  subMonths,
  startOfMonth,
  endOfMonth,
  formatISO,
  startOfYear,
  endOfDay,
  startOfDay,
  subDays,
  startOfHour,
  subHours,
} from 'date-fns';

export const MONTHS_IN_PERIOD = 6;
export const YEARS_IN_PERIOD = 6;
export const DAYS_IN_PERIOD = 16;
export const HOURS_IN_PERIOD = 24;
export const HOURS_IN_FIFTEEN_MIN_PERIOD = 4;

export const getFirstAndLastDayOfLastSixYears = (currentDate?: Date): { startDate: string; endDate: string } => {
  const date = currentDate ?? new Date();
  const currentYear = date.getFullYear();
  return {
    startDate: `${currentYear - 5}-01-01`,
    endDate: `${currentYear}-12-31`,
  };
};

export const getFirstAndLastDayOfLastSixMonths = (currentDate?: Date): { startDate: string; endDate: string } => {
  const date = currentDate ?? new Date();
  const startDate = startOfMonth(subMonths(date, 5));
  const endDate = endOfMonth(date);

  return {
    startDate: formatISO(startDate, { representation: 'date' }),
    endDate: formatISO(endDate, { representation: 'date' }),
  };
};

export const getFirstDayOfMonth = (dateString?: string) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  return formatISO(startOfMonth(date), { representation: 'date' });
};

export const getFirstDayOfYear = (dateString?: string) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  return formatISO(startOfYear(date), { representation: 'date' });
};

export const getFirstAndLastDayOfLastSixteenDays = (currentDate?: Date): { startDate: string; endDate: string } => {
  const date = currentDate ?? new Date();
  const startDate = startOfDay(subDays(date, 15));
  const endDate = endOfDay(date);

  return {
    startDate: formatISO(startDate, { representation: 'date' }),
    endDate: formatISO(endDate, { representation: 'date' }),
  };
};

export const getFirstAndLastHourOfLastTwentyFourHours = (
  currentDate?: Date,
): { startDate: string; endDate: string } => {
  const date = currentDate ?? new Date();
  const startDate = startOfDay(date);
  const endDate = endOfDay(date);

  return {
    startDate: formatISO(startDate),
    endDate: formatISO(endDate),
  };
};

export const getFirstAndLastFifteenMinOfLastFourHours = (
  currentDate?: Date,
): { startDate: string; endDate: string } => {
  const date = currentDate ?? new Date();
  const startDate = startOfHour(subHours(date, 4));
  const endDate = startOfHour(date);

  return {
    startDate: formatISO(startDate),
    endDate: formatISO(endDate),
  };
};
